/* import __COLOCATED_TEMPLATE__ from './tutorials-entry-point.hbs'; */
/* RESPONSIBLE TEAM: team-fin-nux */

import templateOnlyComponent from '@ember/component/template-only';

const TutorialsEntryPoint = templateOnlyComponent();

export default TutorialsEntryPoint;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::TutorialsEntryPoint': typeof TutorialsEntryPoint;
  }
}
